import { useSessionData } from "@/stores/SessionDataContext";
import { type ClassValue, clsx } from "clsx";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function useAirportProduction(airportCode: string) {
  const [isProd, setIsProd] = useState(false);
  const { code_iata } = useSessionData();

  useEffect(() => {
    // @ts-ignore
    setIsProd(import.meta.env.MODE === "production");
  }, []);

  // In development: show for all airports
  // In production: only show for the specified airport
  return !isProd || (isProd && code_iata === airportCode);
}
